import React from 'react';
import { MetricTable } from '@components/noc-metric-panel';
import { ContentWrapper } from '../../styled';

function Content() {
  return (
    <ContentWrapper >
      <MetricTable />
    </ContentWrapper>
  );
}

export default Content;
